"use strict";

var _regeneratorRuntime = require("/root/workspace/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/root/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/root/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/root/workspace/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/root/workspace/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/root/workspace/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/root/workspace/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var assert_1 = __importDefault(require("assert"));

var React = __importStar(require("react"));

var LinkEditor_1 = __importDefault(require("./LinkEditor"));

var FloatingToolbar_1 = __importDefault(require("./FloatingToolbar"));

var createAndInsertLink_1 = __importDefault(require("../commands/createAndInsertLink"));

function isActive(props) {
  var view = props.view;
  var selection = view.state.selection;
  var paragraph = view.domAtPos(selection.$from.pos);
  return props.isActive && !!paragraph.node;
}

var LinkToolbar = /*#__PURE__*/function (_React$Component) {
  _inherits(LinkToolbar, _React$Component);

  var _super = _createSuper(LinkToolbar);

  function LinkToolbar() {
    var _this;

    _classCallCheck(this, LinkToolbar);

    _this = _super.apply(this, arguments);
    _this.menuRef = React.createRef();
    _this.state = {
      left: -1000,
      top: undefined
    };

    _this.handleClickOutside = function (ev) {
      if (ev.target && _this.menuRef.current && _this.menuRef.current.contains(ev.target)) {
        return;
      }

      _this.props.onClose();
    };

    _this.handleOnCreateLink = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(title) {
        var _this$props, dictionary, onCreateLink, view, onClose, onShowToast, dispatch, state, _state$selection, from, to, href;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, dictionary = _this$props.dictionary, onCreateLink = _this$props.onCreateLink, view = _this$props.view, onClose = _this$props.onClose, onShowToast = _this$props.onShowToast;
                onClose();

                _this.props.view.focus();

                if (onCreateLink) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                dispatch = view.dispatch, state = view.state;
                _state$selection = state.selection, from = _state$selection.from, to = _state$selection.to;
                assert_1.default(from === to);
                href = "creating#".concat(title, "\u2026");
                dispatch(view.state.tr.insertText(title, from, to).addMark(from, to + title.length, state.schema.marks.link.create({
                  href: href
                })));
                createAndInsertLink_1.default(view, title, href, {
                  onCreateLink: onCreateLink,
                  onShowToast: onShowToast,
                  dictionary: dictionary
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleOnSelectLink = function (_ref2) {
      var href = _ref2.href,
          title = _ref2.title;
      var _this$props2 = _this.props,
          view = _this$props2.view,
          onClose = _this$props2.onClose;
      onClose();

      _this.props.view.focus();

      var dispatch = view.dispatch,
          state = view.state;
      var _state$selection2 = state.selection,
          from = _state$selection2.from,
          to = _state$selection2.to;
      assert_1.default(from === to);
      dispatch(view.state.tr.insertText(title, from, to).addMark(from, to + title.length, state.schema.marks.link.create({
        href: href
      })));
    };

    return _this;
  }

  _createClass(LinkToolbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("mousedown", this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          onCreateLink = _a.onCreateLink,
          onClose = _a.onClose,
          rest = __rest(_a, ["onCreateLink", "onClose"]);

      var selection = this.props.view.state.selection;
      return React.createElement(FloatingToolbar_1.default, Object.assign({
        ref: this.menuRef,
        active: isActive(this.props)
      }, rest), isActive(this.props) && React.createElement(LinkEditor_1.default, Object.assign({
        from: selection.from,
        to: selection.to,
        onCreateLink: onCreateLink ? this.handleOnCreateLink : undefined,
        onSelectLink: this.handleOnSelectLink,
        onRemoveLink: onClose
      }, rest)));
    }
  }]);

  return LinkToolbar;
}(React.Component);

exports.default = LinkToolbar;